import React from 'react';
import { useParams } from 'react-router-dom';
import { BookOpen } from 'lucide-react';
import { WorkbookShell } from '../../components/reach/workbook/WorkbookShell';

export const WorkbookPage: React.FC = () => {
  const { projectId } = useParams<{ projectId: string }>();
  if (!projectId) return null;

  return (
    <div className="flex-1 overflow-y-auto p-8 font-display">
      <div className="w-full max-w-[1400px] mx-auto flex flex-col gap-6">
        <header className="flex items-center gap-4 border-b border-slate-200 pb-6">
          <div className="flex items-center justify-center w-10 h-10 rounded-full bg-primary/10 text-primary">
            <BookOpen size={22} />
          </div>
          <div>
            <h1 className="text-2xl font-bold tracking-tight text-navy">Engagement Workbook</h1>
            <p className="text-slate-500 text-sm font-medium">Weekly pulse, adoption tracker, and CM playbook</p>
          </div>
        </header>
        <WorkbookShell projectId={projectId} />
      </div>
    </div>
  );
};
